// Slot geometry for the River: which slots fall in a time window, keyed globally.
import { clock } from "../stream";

const { barAt, barContent, slotStartMs, SLOTS_PER_DAY, SLOT_MS } = clock;

export interface SlotRef {
  day: number;
  slot: number;
  startMs: number;
  key: string;
}

export function slotRef(day: number, slot: number, epoch: number): SlotRef {
  return { day, slot, startMs: slotStartMs(day, slot, epoch), key: `${day}:${slot}` };
}

/** The slot sounding at `t` (the dawn bar belongs to the day's last slot). */
export function slotAt(t: number, epoch: number): SlotRef {
  const c = barContent(barAt(t, epoch));
  return c.kind === "dawn" ? slotRef(c.day, SLOTS_PER_DAY - 1, epoch) : slotRef(c.day, c.slot, epoch);
}

export function nextSlot(s: SlotRef, epoch: number): SlotRef {
  return s.slot + 1 >= SLOTS_PER_DAY ? slotRef(s.day + 1, 0, epoch) : slotRef(s.day, s.slot + 1, epoch);
}

export function prevSlot(s: SlotRef, epoch: number): SlotRef {
  return s.slot === 0 ? slotRef(s.day - 1, SLOTS_PER_DAY - 1, epoch) : slotRef(s.day, s.slot - 1, epoch);
}

/** Slots overlapping [t0, t1). */
export function slotsBetween(t0: number, t1: number, epoch: number): SlotRef[] {
  const out: SlotRef[] = [];
  let s = slotAt(t0, epoch);
  while (s.startMs < t1 && out.length < 200) {
    if (s.startMs + SLOT_MS > t0) out.push(s);
    s = nextSlot(s, epoch);
  }
  return out;
}

export function formatClock(ms: number, withSeconds = true): string {
  return new Date(ms).toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: withSeconds ? "2-digit" : undefined,
  });
}

export function formatPlayTime(ms: number): string {
  const d = new Date(ms);
  return `${d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" })}, ${d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", second: "2-digit" })}`;
}

export function formatDuration(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}
